var _rect, _path, _rect2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 26,
    viewBox: "0 0 26 26",
    width: 26,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    height: 25,
    rx: 12.5,
    width: 25,
    x: 0.5,
    y: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m19.4818 6.51818c-3.5798-3.5798-9.3838-3.5798-12.96362 0-3.5798 3.57982-3.5798 9.38382 0 12.96362 3.57982 3.5798 9.38382 3.5798 12.96362 0s3.5798-9.3838 0-12.96362zm.5893-.58926c3.9052 3.90524 3.9052 10.23688 0 14.14218-3.9053 3.9052-10.23688 3.9052-14.14217 0-3.90524-3.9053-3.90524-10.23688 0-14.14217 3.90523-3.90524 10.23687-3.90524 14.14217-.00001z",
    fill: "#0d8b69",
    fillRule: "evenodd"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    height: 25,
    rx: 12.5,
    stroke: "#fff",
    width: 25,
    x: 0.5,
    y: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCircle);
export default __webpack_public_path__ + "static/media/ico_circle.282c301bc93cc5a19e90ad5194aa0bda.svg";
export { ForwardRef as ReactComponent };